import { zonedTimeToUtc } from 'date-fns-tz';
import { TIMEZONE } from 'config';

function getUTCDate(date, timezone) {
  return zonedTimeToUtc(date, timezone || TIMEZONE);
}

export default getUTCDate;
